// extracted by mini-css-extract-plugin
export var printerCard = "_c3-1";
export var printerCardConfigured = "_c3-2";
export var printerCardError = "_c3-3";
export var printerCardsContainer = "_c3-0";
export var printerIcon = "_c3-8";
export var printerIconConfigured = "_c3-5";
export var printerIconContainer = "_c3-4";
export var printerIconError = "_c3-6";
export var printerIconUnconfigured = "_c3-7";
export var workstationsTableCard = "_c3-9";